
NgConfig.$inject = ['$translateProvider', '$translatePartialLoaderProvider'];

export function NgConfig($translateProvider, $translatePartialLoaderProvider) {

    $translateProvider.uniformLanguageTag('bcp47');
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.fallbackLanguage('en-US');
    $translatePartialLoaderProvider.addPart('app-platform');
    $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: window.sps.$Constants.languagePath + '/{lang}.json'
    });

}
